module.exports = __webpack_public_path__ + "media/images/lb/847-9c7e54bfa0fa33120cef36d0d0f366fb.svg";